
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ChipMultiSelect extends Vue {
  @Prop() value!: Record<string, boolean>

  handleSelection(key: string) {
    const updatedSelection = this.value
    updatedSelection[key] = !this.value[key]

    this.$emit('change', updatedSelection)
  }
}
